module.exports = __webpack_public_path__ + "images/emoji/white_circle.aeb8b367ada094d8a8f2.png";